import { Group, Menu } from '@mantine/core';
import {
  IconCalendarEvent,
  IconDeviceFloppy,
  IconDotsCircleHorizontal,
  IconEye,
  IconFiles,
  IconTrash,
} from '@tabler/icons';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ActionIconWithText from './ActionIconWithText';

interface Props {
  saveAsTemplate: () => void;
  showPreview: () => void;
  remove: () => void;
}

const ContractEditorFooter: FC<Props> = ({ saveAsTemplate, showPreview, remove }) => {
  const { id: eventId } = useParams();
  const navigate = useNavigate();

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText label="Details" onClick={() => navigate(`/events/${eventId}/details`)}>
        <IconCalendarEvent />
      </ActionIconWithText>
      <ActionIconWithText label="Dateien" onClick={() => navigate(`/events/${eventId}/documents`)}>
        <IconFiles />
      </ActionIconWithText>
      <ActionIconWithText useDefaultWidth label="Vorschau" onClick={showPreview}>
        <IconEye />
      </ActionIconWithText>
      <Menu withArrow shadow="md" width={180} transition="slide-up" position="top-end">
        <Menu.Target>
          <div>
            <ActionIconWithText label="Mehr">
              <IconDotsCircleHorizontal />
            </ActionIconWithText>
          </div>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item onClick={saveAsTemplate} icon={<IconDeviceFloppy size={16} />}>
            Vorlage speichern
          </Menu.Item>
          <Menu.Item color="red" onClick={remove} icon={<IconTrash size={16} />}>
            Löschen
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};

export default ContractEditorFooter;
